import { createFileRoute } from '@tanstack/react-router';

import { NotificationsPage } from '@/components/notifications-page/notifications-page';

export const Route = createFileRoute('/_authenticated/notifications')({
  staticData: {
    title: 'route.notifications.title',
  },
  component: NotificationsPage,
});
